<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="directoryService.showDetailedView"
         [ngStyle]="{width: directoryService.showDetailedView ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content">
            <div class="row">
                <div [ngClass]="{'col-sm-9': !showArchivedItemsFilter() || currentTabId == 'vendors',
                                 'col-sm-7': showArchivedItemsFilter() || currentTabId == 'vendors'}">
                    <filter [tabHeading]="getActiveTabTitle()"
                            [buildings]="currentTabId != 'vendors' ? directoryService.buildingsForRead : []"></filter>
                </div>

                <directory-archived-items-filter *ngIf="showArchivedItemsFilter()"></directory-archived-items-filter>
                <vendors-filter *ngIf="currentTabId == 'vendors'"></vendors-filter>

                <div *ngIf="(directoryService.account.canUpdate('bldn') && currentTabId != 'updates' && currentTabId != 'vendors') ||
                            (currentTabId == 'vendors' && directoryService.account.canUpdate('vendors_directory'))"
                     class="col-sm-3">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="directoryService.showModal()">
                        <i class="fa fa-plus-circle"></i> Add {{getActiveTabTitle()}}
                    </button>
                </div>

                <div class="col-sm-12" [hidden]="!showArchivedItemsFilter() && currentTabId != 'vendors'">
                    <filters-view></filters-view>
                </div>
            </div>

            <div class="flex-fill" [ngClass]="{'sk-loading':directoryService.spinnerShow}">
                <tabs-wrapper>
                    <tab-item title="Updates"
                              [tabId]="'updates'"
                              [numberLabel]="directoryService.directoryData.updates.total"
                              *ngIf="(directoryService.directoryData.updates.total > 0 || currentTabId == 'updates')">
                        <updates-list *ngIf="currentTabId == 'updates'"></updates-list>
                    </tab-item>
                    <tab-item title="Residents" [tabId]="'residents'">
                        <residents-list *ngIf="currentTabId == 'residents'"></residents-list>
                    </tab-item>
                    <tab-item title="Units" [tabId]="'units'">
                        <units-list *ngIf="currentTabId == 'units'"></units-list>
                    </tab-item>
                    <tab-item title="Parking Spots" [tabId]="'parking-spots'">
                        <parking-spots-list *ngIf="currentTabId == 'parking-spots'"></parking-spots-list>
                    </tab-item>
                    <tab-item title="Lockers" [tabId]="'lockers'">
                        <lockers-list *ngIf="currentTabId == 'lockers'"></lockers-list>
                    </tab-item>
                    <tab-item title="Vehicles" [tabId]="'vehicles'">
                        <vehicles-list *ngIf="currentTabId == 'vehicles'"></vehicles-list>
                    </tab-item>
                    <tab-item title="Pets" [tabId]="'pets'">
                        <pets-list *ngIf="currentTabId == 'pets'"></pets-list>
                    </tab-item>
                    <tab-item title="Bike Racks" [tabId]="'bike-racks'">
                        <bike-racks-list *ngIf="currentTabId == 'bike-racks'"></bike-racks-list>
                    </tab-item>
                    <tab-item title="Vendors" [tabId]="'vendors'" *ngIf="directoryService.account.canRead('vendors_directory')">
                        <vendors-list *ngIf="currentTabId == 'vendors'"></vendors-list>
                    </tab-item>
                    <pagination *ngIf="currentTabId && directoryService.directoryData[currentTabId].total
                                           && urlService.queryParams['page']"
                                [total]="directoryService.directoryData[currentTabId].total">
                    </pagination>
                    <spinner [spinnerShow]="directoryService.spinnerShow"></spinner>
                </tabs-wrapper>
            </div>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar"
         *ngIf="directoryService.showDetailedView">
        <resident-view      *ngIf="currentTabId == 'residents'"></resident-view>
        <unit-view          *ngIf="currentTabId == 'units'"></unit-view>
        <parking-spot-view  *ngIf="currentTabId == 'parking-spots'"></parking-spot-view>
        <locker-view        *ngIf="currentTabId == 'lockers'"></locker-view>
        <vehicle-view       *ngIf="currentTabId == 'vehicles'"></vehicle-view>
        <pet-view           *ngIf="currentTabId == 'pets'"></pet-view>
        <bike-rack-view     *ngIf="currentTabId == 'bike-racks'"></bike-rack-view>
        <vendor-view        *ngIf="currentTabId == 'vendors'"></vendor-view>
    </div>
</div>


<div class="boxForModal" *ngIf="directoryService.showCreateModal">
    <resident-create     *ngIf="currentTabId == 'residents'"     ></resident-create>
    <unit-create         *ngIf="currentTabId == 'units'"         ></unit-create>
    <parking-spot-create *ngIf="currentTabId == 'parking-spots'" ></parking-spot-create>
    <locker-create       *ngIf="currentTabId == 'lockers'"       ></locker-create>
    <vehicle-create      *ngIf="currentTabId == 'vehicles'"      ></vehicle-create>
    <pet-create          *ngIf="currentTabId == 'pets'"          ></pet-create>
    <bike-rack-create    *ngIf="currentTabId == 'bike-racks'"    ></bike-rack-create>
    <vendor-create-modal *ngIf="currentTabId == 'vendors'"       ></vendor-create-modal>
</div>

<add-instructions-modal *ngIf="directoryService.showAddInstructionsModal"></add-instructions-modal>
<move-out-modal *ngIf="directoryService.showMoveOutModal"></move-out-modal>
<send-invitation-modal *ngIf="directoryService.showSendInvitationModal"></send-invitation-modal>
<reset-password-modal *ngIf="directoryService.showResetPasswordModal"></reset-password-modal>
<change-unit-modal *ngIf="directoryService.isShowChangeUnitModal"></change-unit-modal>
<amenities-modal *ngIf="amenitiesService.isAmenityModalShow"></amenities-modal>
<parking-pass-modal *ngIf="parkingPassService.isParkingPassModalShow"></parking-pass-modal>
<account-balance-modal *ngIf="condomanagerService.accountStatementModalDetails"></account-balance-modal>
<user-updates-modal *ngIf="directoryService.userUpdateModalData"
                    [patch]="directoryService.userUpdateModalData"
                    (patched)="directoryService.getData()">
</user-updates-modal>
<capture-image-modal *ngIf="directoryService.showImageCaptureModal"
                     (onClose)="directoryService.onImageCaptureModalClose($event)">
</capture-image-modal>
<send-sms-modal *ngIf="directoryService.showSmsModal"></send-sms-modal>



// WEBPACK FOOTER //
// /app/src/app/views/directory/directory.component.html